import { Trans, useTranslation } from 'react-i18next';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@parrot-software/design-system';

/**
 * Props for InvoiceDataAssignedDialog component
 */
export interface InvoiceDataAssignedDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onClose: () => void;
}

/**
 * Informational dialog shown when the user tries to delete an invoice data
 * that is currently assigned to one or more subscription blocks.
 * Exposes a single action button to close the dialog.
 */
export const InvoiceDataAssignedDialog = ({ open, onOpenChange, onClose }: InvoiceDataAssignedDialogProps) => {
  const { t } = useTranslation('invoiceData');

  return (
    <AlertDialog onOpenChange={onOpenChange} open={open}>
      <AlertDialogContent className="max-w-[451px] font-sans">
        <AlertDialogHeader>
          <AlertDialogTitle>{t('deleteBlocked.title')}</AlertDialogTitle>
          <AlertDialogDescription className="space-y-3 text-muted-foreground">
            <p>
              <Trans
                components={{ bold: <strong className="font-semibold" /> }}
                i18nKey="invoiceData:deleteBlocked.descriptionLine1"
              />
            </p>
            <p>
              <Trans
                components={{ bold: <strong className="font-semibold" /> }}
                i18nKey="invoiceData:deleteBlocked.descriptionLine2"
              />
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter>
          <AlertDialogAction onClick={onClose}>{t('deleteBlocked.closeButton')}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
